/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.urls.rpc.ScreenshotRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './ScreenshotRpc';
import * as Queries from './ScreenshotRpc.dfc.new';
import type { AdditionalContextArgs } from './ScreenshotRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetScreenshotQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetScreenshotResponseType>,
    References.GetScreenshotRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getScreenshot', References.GetScreenshotResponseType>
        : References.GetScreenshotResponseType)
    | undefined;
};

export function useGetScreenshotQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetScreenshotResponseType>,
    References.GetScreenshotRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetScreenshotQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_SCREENSHOT_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getScreenshot: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetScreenshotQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetScreenshotQueryReturn<T>;
}

type UseGetScreenshotLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetScreenshotResponseType>,
    References.GetScreenshotRequestType,
    T extends true
      ? Record<'getScreenshot', References.GetScreenshotResponseType>
      : References.GetScreenshotResponseType
  >;

export function useGetScreenshotLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetScreenshotResponseType>,
    References.GetScreenshotRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetScreenshotLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SCREENSHOT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getScreenshot: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetScreenshotLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetScreenshotLazyQueryReturn<T>;
}

type UseGetScreenshotSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetScreenshotResponseType>,
    References.GetScreenshotRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getScreenshot', References.GetScreenshotResponseType>
    : References.GetScreenshotResponseType;
};

export function useGetScreenshotSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetScreenshotResponseType>,
    References.GetScreenshotRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetScreenshotSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SCREENSHOT_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getScreenshot: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetScreenshotSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetScreenshotSuspenseQueryReturn<T>;
}

type UseGetScreenshotV2QueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetScreenshotV2ResponseType>,
    References.GetScreenshotV2RequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getScreenshotV2', References.GetScreenshotV2ResponseType>
        : References.GetScreenshotV2ResponseType)
    | undefined;
};

export function useGetScreenshotV2Query<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetScreenshotV2ResponseType>,
    References.GetScreenshotV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetScreenshotV2QueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_SCREENSHOT_V2_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getScreenshotV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetScreenshotV2QueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetScreenshotV2QueryReturn<T>;
}

type UseGetScreenshotV2LazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetScreenshotV2ResponseType>,
    References.GetScreenshotV2RequestType,
    T extends true
      ? Record<'getScreenshotV2', References.GetScreenshotV2ResponseType>
      : References.GetScreenshotV2ResponseType
  >;

export function useGetScreenshotV2LazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetScreenshotV2ResponseType>,
    References.GetScreenshotV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetScreenshotV2LazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_SCREENSHOT_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getScreenshotV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetScreenshotV2LazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetScreenshotV2LazyQueryReturn<T>;
}

type UseGetScreenshotV2SuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetScreenshotV2ResponseType>,
    References.GetScreenshotV2RequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getScreenshotV2', References.GetScreenshotV2ResponseType>
    : References.GetScreenshotV2ResponseType;
};

export function useGetScreenshotV2SuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetScreenshotV2ResponseType>,
    References.GetScreenshotV2RequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetScreenshotV2SuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_SCREENSHOT_V2_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getScreenshotV2: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetScreenshotV2SuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetScreenshotV2SuspenseQueryReturn<T>;
}
